// modules are defined as an array
// [ module function, map of requires ]
//
// map of requires is short require name -> numeric require
//
// anything defined in a previous bundle is accessed via the
// orig method which is the require for previous bundles

(function (
  modules,
  entry,
  mainEntry,
  parcelRequireName,
  externals,
  distDir,
  publicUrl,
  devServer
) {
  /* eslint-disable no-undef */
  var globalObject =
    typeof globalThis !== 'undefined'
      ? globalThis
      : typeof self !== 'undefined'
      ? self
      : typeof window !== 'undefined'
      ? window
      : typeof global !== 'undefined'
      ? global
      : {};
  /* eslint-enable no-undef */

  // Save the require from previous bundle to this closure if any
  var previousRequire =
    typeof globalObject[parcelRequireName] === 'function' &&
    globalObject[parcelRequireName];

  var importMap = previousRequire.i || {};
  var cache = previousRequire.cache || {};
  // Do not use `require` to prevent Webpack from trying to bundle this call
  var nodeRequire =
    typeof module !== 'undefined' &&
    typeof module.require === 'function' &&
    module.require.bind(module);

  function newRequire(name, jumped) {
    if (!cache[name]) {
      if (!modules[name]) {
        if (externals[name]) {
          return externals[name];
        }
        // if we cannot find the module within our internal map or
        // cache jump to the current global require ie. the last bundle
        // that was added to the page.
        var currentRequire =
          typeof globalObject[parcelRequireName] === 'function' &&
          globalObject[parcelRequireName];
        if (!jumped && currentRequire) {
          return currentRequire(name, true);
        }

        // If there are other bundles on this page the require from the
        // previous one is saved to 'previousRequire'. Repeat this as
        // many times as there are bundles until the module is found or
        // we exhaust the require chain.
        if (previousRequire) {
          return previousRequire(name, true);
        }

        // Try the node require function if it exists.
        if (nodeRequire && typeof name === 'string') {
          return nodeRequire(name);
        }

        var err = new Error("Cannot find module '" + name + "'");
        err.code = 'MODULE_NOT_FOUND';
        throw err;
      }

      localRequire.resolve = resolve;
      localRequire.cache = {};

      var module = (cache[name] = new newRequire.Module(name));

      modules[name][0].call(
        module.exports,
        localRequire,
        module,
        module.exports,
        globalObject
      );
    }

    return cache[name].exports;

    function localRequire(x) {
      var res = localRequire.resolve(x);
      return res === false ? {} : newRequire(res);
    }

    function resolve(x) {
      var id = modules[name][1][x];
      return id != null ? id : x;
    }
  }

  function Module(moduleName) {
    this.id = moduleName;
    this.bundle = newRequire;
    this.require = nodeRequire;
    this.exports = {};
  }

  newRequire.isParcelRequire = true;
  newRequire.Module = Module;
  newRequire.modules = modules;
  newRequire.cache = cache;
  newRequire.parent = previousRequire;
  newRequire.distDir = distDir;
  newRequire.publicUrl = publicUrl;
  newRequire.devServer = devServer;
  newRequire.i = importMap;
  newRequire.register = function (id, exports) {
    modules[id] = [
      function (require, module) {
        module.exports = exports;
      },
      {},
    ];
  };

  // Only insert newRequire.load when it is actually used.
  // The code in this file is linted against ES5, so dynamic import is not allowed.
  // INSERT_LOAD_HERE

  Object.defineProperty(newRequire, 'root', {
    get: function () {
      return globalObject[parcelRequireName];
    },
  });

  globalObject[parcelRequireName] = newRequire;

  for (var i = 0; i < entry.length; i++) {
    newRequire(entry[i]);
  }

  if (mainEntry) {
    // Expose entry point to Node, AMD or browser globals
    // Based on https://github.com/ForbesLindesay/umd/blob/master/template.js
    var mainExports = newRequire(mainEntry);

    // CommonJS
    if (typeof exports === 'object' && typeof module !== 'undefined') {
      module.exports = mainExports;

      // RequireJS
    } else if (typeof define === 'function' && define.amd) {
      define(function () {
        return mainExports;
      });
    }
  }
})({"1MY8f":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "ErrorText", ()=>ErrorText);
var _jsxRuntime = require("react/jsx-runtime");
var _reactRouter = require("react-router");
var _hero = require("@/components/hero");
"use client";
function ErrorText() {
    const error = (0, _reactRouter.useRouteError)();
    let title = "Oops!";
    let description = "Sorry, an unexpected error has occurred.";
    if ((0, _reactRouter.isRouteErrorResponse)(error)) {
        title = String(error.status);
        description = error.statusText;
    }
    return /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _jsxRuntime.Fragment), {
        children: [
            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _hero.HeroTitle), {
                children: title
            }),
            !!description && /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _hero.HeroDescription), {
                children: description
            })
        ]
    });
}

},{"react/jsx-runtime":"5QkRR","react-router":"cCbjc","@/components/hero":"6pyLK","@parcel/transformer-js/src/esmodule-helpers.js":"3CMC9"}],"6pyLK":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "Hero", ()=>Hero);
parcelHelpers.export(exports, "HeroBadges", ()=>HeroBadges);
parcelHelpers.export(exports, "HeroBadge", ()=>HeroBadge);
parcelHelpers.export(exports, "HeroTitle", ()=>HeroTitle);
parcelHelpers.export(exports, "HeroDescription", ()=>HeroDescription);
parcelHelpers.export(exports, "HeroButtons", ()=>HeroButtons);
parcelHelpers.export(exports, "HeroCards", ()=>HeroCards);
parcelHelpers.export(exports, "HeroCard", ()=>HeroCard);
var _jsxRuntime = require("react/jsx-runtime");
var _badge = require("@/components/ui/badge");
var _utils = require("@/lib/utils");
function Hero({ children }) {
    return /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
        className: "relative overflow-hidden",
        children: [
            /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                className: "absolute inset-0 -z-10",
                children: [
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                        className: "absolute top-0 left-0 w-full h-full bg-gradient-to-br from-amber-50/30 via-emerald-50/20 to-purple-50/30"
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                        className: "absolute top-1/4 left-1/3 w-64 h-64 rounded-full bg-emerald-200/20 blur-3xl"
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                        className: "absolute bottom-1/4 right-1/3 w-80 h-80 rounded-full bg-amber-200/20 blur-3xl"
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                        className: "absolute top-1/2 right-1/4 w-72 h-72 rounded-full bg-purple-200/20 blur-3xl"
                    })
                ]
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                className: "container px-4 py-24 mx-auto md:py-32",
                children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                    className: "flex flex-col items-center max-w-5xl mx-auto text-center",
                    children: children
                })
            })
        ]
    });
}
function HeroBadges({ children }) {
    return /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
        className: "flex items-center flex-wrap justify-center gap-2 mb-6",
        children: children
    });
}
function HeroBadge({ children, className }) {
    return /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _badge.Badge), {
        className: (0, _utils.cn)("px-3 py-1 text-sm", className),
        children: children
    });
}
function HeroTitle({ children, className }) {
    return /*#__PURE__*/ (0, _jsxRuntime.jsx)("h1", {
        className: (0, _utils.cn)("mb-6 text-5xl font-bold tracking-tight text-zinc-900 md:text-6xl lg:text-7xl", className),
        children: children
    });
}
function HeroDescription({ children, className }) {
    return /*#__PURE__*/ (0, _jsxRuntime.jsx)("p", {
        className: (0, _utils.cn)("max-w-2xl mb-8 text-lg text-zinc-600 md:text-xl", className),
        children: children
    });
}
function HeroButtons({ children, className }) {
    return /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
        className: (0, _utils.cn)("grid w-full max-w-md grid-cols-1 gap-4 sm:grid-cols-2", className),
        children: children
    });
}
function HeroCards({ children }) {
    return /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
        className: "grid grid-cols-2 gap-4 mt-16 sm:grid-cols-4",
        children: children
    });
}
function HeroCard({ children }) {
    return /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
        className: "p-6 text-center rounded-lg bg-white/80 backdrop-blur-sm",
        children: children
    });
}

},{"react/jsx-runtime":"5QkRR","@/components/ui/badge":"1tlFu","@/lib/utils":"dGaHd","@parcel/transformer-js/src/esmodule-helpers.js":"3CMC9"}],"1tlFu":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "Badge", ()=>Badge);
parcelHelpers.export(exports, "badgeVariants", ()=>badgeVariants);
var _jsxRuntime = require("react/jsx-runtime");
var _react = require("react");
var _classVarianceAuthority = require("class-variance-authority");
var _utils = require("@/lib/utils");
const badgeVariants = (0, _classVarianceAuthority.cva)("inline-flex items-center justify-center rounded-md border px-2 py-0.5 text-xs font-medium w-fit whitespace-nowrap shrink-0 [&>svg]:size-3 gap-1 [&>svg]:pointer-events-none focus-visible:border-ring focus-visible:ring-ring/50 focus-visible:ring-[3px] aria-invalid:ring-destructive/20 dark:aria-invalid:ring-destructive/40 aria-invalid:border-destructive transition-[color,box-shadow] overflow-hidden", {
    variants: {
        variant: {
            default: "border-transparent bg-primary text-primary-foreground [a&]:hover:bg-primary/90",
            secondary: "border-transparent bg-secondary text-secondary-foreground [a&]:hover:bg-secondary/90",
            destructive: "border-transparent bg-destructive text-white [a&]:hover:bg-destructive/90 focus-visible:ring-destructive/20 dark:focus-visible:ring-destructive/40 dark:bg-destructive/60",
            outline: "text-foreground [a&]:hover:bg-accent [a&]:hover:text-accent-foreground"
        }
    },
    defaultVariants: {
        variant: "default"
    }
});
function Badge({ className, variant, asChild = false, ...props }) {
    const Comp = asChild ? (props)=>/*#__PURE__*/ _react.cloneElement(props.children, {
            ...props,
            children: props.children.props.children
        }) : "span";
    return /*#__PURE__*/ (0, _jsxRuntime.jsx)(Comp, {
        "data-slot": "badge",
        className: (0, _utils.cn)(badgeVariants({
            variant
        }), className),
        ...props
    });
}

},{"react/jsx-runtime":"5QkRR","react":"fud5f","class-variance-authority":"glzT5","@/lib/utils":"dGaHd","@parcel/transformer-js/src/esmodule-helpers.js":"3CMC9"}],"glzT5":[function(require,module,exports,__globalThis) {
/**
 * Copyright 2022 Joe Bell. All rights reserved.
 *
 * This file is licensed to you under the Apache License, Version 2.0
 * (the "License"); you may not use this file except in compliance with the
 * License. You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS, WITHOUT
 * WARRANTIES OR REPRESENTATIONS OF ANY KIND, either express or implied. See the
 * License for the specific language governing permissions and limitations under
 * the License.
 */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "cx", ()=>cx);
parcelHelpers.export(exports, "cva", ()=>cva);
var _clsx = require("clsx");
const falsyToString = (value)=>typeof value === "boolean" ? `${value}` : value === 0 ? "0" : value;
const cx = (0, _clsx.clsx);
const cva = (base, config)=>(props)=>{
        var _config_compoundVariants;
        if ((config === null || config === void 0 ? void 0 : config.variants) == null) return cx(base, props === null || props === void 0 ? void 0 : props.class, props === null || props === void 0 ? void 0 : props.className);
        const { variants, defaultVariants } = config;
        const getVariantClassNames = Object.keys(variants).map((variant)=>{
            const variantProp = props === null || props === void 0 ? void 0 : props[variant];
            const defaultVariantProp = defaultVariants === null || defaultVariants === void 0 ? void 0 : defaultVariants[variant];
            if (variantProp === null) return null;
            const variantKey = falsyToString(variantProp) || falsyToString(defaultVariantProp);
            return variants[variant][variantKey];
        });
        const propsWithoutUndefined = props && Object.entries(props).reduce((acc, param)=>{
            let [key, value] = param;
            if (value === undefined) return acc;
            acc[key] = value;
            return acc;
        }, {});
        const getCompoundVariantClassNames = config === null || config === void 0 ? void 0 : (_config_compoundVariants = config.compoundVariants) === null || _config_compoundVariants === void 0 ? void 0 : _config_compoundVariants.reduce((acc, param)=>{
            let { class: cvClass, className: cvClassName, ...compoundVariantOptions } = param;
            return Object.entries(compoundVariantOptions).every((param)=>{
                let [key, value] = param;
                return Array.isArray(value) ? value.includes({
                    ...defaultVariants,
                    ...propsWithoutUndefined
                }[key]) : ({
                    ...defaultVariants,
                    ...propsWithoutUndefined
                })[key] === value;
            }) ? [
                ...acc,
                cvClass,
                cvClassName
            ] : acc;
        }, []);
        return cx(base, getVariantClassNames, getCompoundVariantClassNames, props === null || props === void 0 ? void 0 : props.class, props === null || props === void 0 ? void 0 : props.className);
    };

},{"clsx":"fi8Q7","@parcel/transformer-js/src/esmodule-helpers.js":"3CMC9"}]},[], null, "parcelRequire6f52", {})

//# sourceMappingURL=root.3118eff5.js.map
